export default "__VITE_ASSET__C0rq0_RD__"